import {Card, getLowCard, getHighCard} from '../../../utils/Deck'
import {probability, randomItem} from '../../../utils'
import {MoveCard} from '../../../types/MoveCard'
import {IRemotePlayer} from '../../../types/IRemotePlayer'
import concat from '../../../utils/Array/concat'
import {getProtectionCards} from '../Deck/Card/getProtectionCards'
import {Winner} from '../Game'

export class BaldaPlayer implements IRemotePlayer {
    public onMove(
        myCards: Card[],
        battleCards: Card[][],
        trump: Card,
        turn: string,
        offset: number,
        countUserCards: number
    ): MoveCard | void {
        if (turn === Winner.Rival) {
            return BaldaPlayer.attackMove(myCards, battleCards, trump, offset, countUserCards)
        } else {
            return BaldaPlayer.protectionMove(myCards, battleCards, trump)
        }
    }

    private static attackMove(
        hand: Card[],
        battle: Card[][],
        trump: Card,
        offset: number,
        countUserCards: number
    ): MoveCard | void {
        if (countUserCards === 0) {
            return
        }
        if (battle.length === 0) {
            let card = null

            if (offset === 36 && countUserCards < 2) {
                console.log('Даём старшую карту')
                card = probability(90) ? getHighCard(hand, trump) : randomItem(hand)
            } else {
                card = probability(80) ? getLowCard(hand, trump) : randomItem(hand)
            }
            return {card: card, index: 0}
        } else {
            const battleCardsConcat = concat(battle) as Card[]

            for (let i = 0; i < battleCardsConcat.length; i++) {
                let bc = battleCardsConcat[i]

                for (let j = 0; j < hand.length; j++) {
                    let mc = hand[j]

                    if (bc.rank === mc.rank) {
                        return {card: mc, index: battle.length}
                    }
                }
            }
        }
    }

    private static protectionMove(hand: Card[], battle: Card[][], trump: Card): MoveCard | void {
        const move = getProtectionCards(hand, battle, trump, true)
        if (move.length) return move[0]
    }
}
